import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const guidelineactionApiService = createApi({
  reducerPath: "guidelineactionApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createGuidelineAction: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `guidelineaction/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getGuidelineAction: builder.query({
      query: ({ id, params }) => {
        let query = queryParams(params);
        if (id) {
          return `guidelineaction/get/${id}${query}`;
        }
        return `guidelineaction/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    getGuidelineNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `guidelineaction/notifications${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    updateGuidelineAction: builder.mutation({
      query: ({ id, body, params }) => {
        let query = queryParams(params);
        return {
          url: `guidelineaction/${id}${query}`,
          method: "PUT",
          body,
        };
      },
    }),
    reportPost: builder.mutation({
      query: ({ body, params }) => {
        let query = queryParams(params);
        return {
          url: `guidelineaction/report${query}`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useCreateGuidelineActionMutation,
  useGetGuidelineActionQuery,
  useGetGuidelineNotificationsQuery,
  useUpdateGuidelineActionMutation,
  useReportPostMutation,
} = guidelineactionApiService;
